var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container",class:{ 'card-container--selected': _vm.selected }},[_vm._m(0),_c('div',{staticClass:"card-container--name"},[_c('p',[_vm._v(_vm._s(_vm.department.nome_setor))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container--img"},[_c('img',{attrs:{"src":require("../../../public/img/icons/hermes-icon-line.png")}})])
}]

export { render, staticRenderFns }